module.exports = __webpack_public_path__ + "img/googlemaps.8333b23c.svg";